import { render } from "./elektraweb.vue?vue&type=template&id=317de108&scoped=true"
import script from "./elektraweb.vue?vue&type=script&lang=js"
export * from "./elektraweb.vue?vue&type=script&lang=js"

import "./elektraweb.vue?vue&type=style&index=0&id=317de108&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317de108"]])

export default __exports__